import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AddressIcon } from "../Icons/AddressIcon";
import { ApplicantsIcon } from "../Icons/ApplicantsIcon";
import { EmailIcon } from "../Icons/EmailIcon";
import { ExperienceIcon } from "../Icons/ExperienceIcon";
import { LinkedInIcon } from "../Icons/LinkedInIcon";
import { PhoneIcon } from "../Icons/PhoneIcon";
import { PriorityIcon } from "../Icons/PriorityIcon";
import { SegmentIcon } from "../Icons/SegmentIcon";
import { Suitcase } from "../Icons/suitcase";
import { Video } from "../Icons/video";
import { clearAuth } from "../_redux/AuthSlice";
import GetJobId from "../_utilities/GetJobId";
import { authService } from "../api/authApi";
import { getRequiredMenu } from "./layoutdata";
import Cookies from "js-cookie";
import getUserDetails, { GetUserInfo } from "../_utilities/getUserInfo";
import { persistor, resetStore } from "../store";
import { truncateWords } from "../_utilities/utilities";
import { updateNextPath } from "../_redux/SelectedNextPath";
import { resetSelectedJobPosting } from "../_redux/SelectedJobPostingSlice";
function NavSidebar({
  drawerWidth,
  menuList,
  menuType,
  isAssociat,
  subPathName,
  aditionalData,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeMenu, setActiveMenu] = useState(null);
  const getJobId = GetJobId();
  const location = useLocation();
  const nextPathValue = useSelector((state) => state.SeletedNextPath.value);
  const [nextpath, setNextpath] = useState("");
  const [subpath, setSubPath] = useState("");
  const { themeSettings } = useSelector((state) => state.theme);

  const [applicantsMenus, setApplicantsMenus] = useState([]);
  const [clientsMenus, setClientsMenus] = useState([]);
  const [customerMenus, setCustomerMenus] = useState([]);
  const [helpSectionMenus, setHelpSectionMenus] = useState([]);
  const [jobPostingMenus, setJobPostingMenus] = useState([]);
  const [projectsMenus, setProjectsMenus] = useState([]);

  const [listSegments, setListSegments] = useState([]);
  const segmentList = useSelector((state) => state.GetListSegments.data);

  useEffect(() => {
    setApplicantsMenus(getRequiredMenu("applicantsMenus", themeSettings));
    setClientsMenus(getRequiredMenu("clientsMenus", themeSettings));
    setCustomerMenus(getRequiredMenu("customerMenus", themeSettings));
    setHelpSectionMenus(getRequiredMenu("helpSectionMenus", themeSettings));
    setJobPostingMenus(getRequiredMenu("jobPostingMenus", themeSettings));
    setProjectsMenus(getRequiredMenu("projectsMenus", themeSettings));
  }, []);

  useEffect(() => {
    if (segmentList && segmentList.length > 0) {
      const activeSegments = segmentList.map(({ id, segmentName }) => ({
        id,
        segmentName,
      }));
      setListSegments(activeSegments);
      if (aditionalData?.segment) {
        aditionalData.segment =
          activeSegments.find(
            (x) => parseInt(x.id) === parseInt(aditionalData.segment),
          )?.segmentName || "";
      }
    }
  }, [segmentList, aditionalData]);

  const onNavigateHandle = (item) => {
    if (item.url.includes("helpsection")) {
      setActiveMenu("helpsection");
      navigate(`${item.url}`);
    } else if (item.url.includes("custom")) {
      setActiveMenu(item.menuName);
      navigate(`${item.url}`);
    } else {
      if(item.url.includes("clients/") || item.url.includes("projects/")){
        dispatch(updateNextPath("null"));
        dispatch(resetSelectedJobPosting());
      }
      setActiveMenu(item.menuName);
      navigate(
        `${item.url}/${isAssociat !== "" ? parseInt(isAssociat) : getJobId}`,
      );
    }
  };

  useEffect(() => {
    const processSubPath = async () => {
      let customerSubpathObj = await getUserDetails();
      const url = location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      let comparePath = "";
      if (Number.isInteger(parseInt(path))) {
        comparePath = removelastSlash(url);
      } else {
        comparePath = url.replace("/ats/layout/", "");
      }
      let filteredData = jobPostingMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      let filteredData1 = applicantsMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      let filteredData2 = clientsMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      let filteredData3 = helpSectionMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      let filteredData4 = customerMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      let filteredData5 = projectsMenus.filter(
        (x) => x.url === comparePath || x.urls === comparePath,
      );
      if (filteredData.length > 0) {
        setActiveMenu(filteredData[0].menuName);
      } else if (filteredData1.length > 0) {
        setActiveMenu(filteredData1[0].menuName);
      } else if (filteredData2.length > 0) {
        setActiveMenu(filteredData2[0].menuName);
      } else if (filteredData3.length > 0) {
        setActiveMenu(filteredData3[0].menuName);
      } else if (filteredData4.length > 0) {
        setActiveMenu(filteredData4[0].menuName);
      } else if (filteredData5.length > 0) {
        setActiveMenu(filteredData5[0].menuName);
      } else {
        setActiveMenu(null);
      }
      if (Number.isInteger(parseInt(path))) {
        let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
        let subpathType =
          menuType === "jobpostings"
            ? "Job Code"
            : menuType === "applicants"
              ? "Applicant Code"
              : menuType === "clients"
                ? "clients"
                : "projects";
        if (
          subpathObj &&
          subpathObj.length > 0 &&
          menuType !== "helpsection" &&
          menuType !== "customer"
        ) {
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === subpathType,
          );
          if (filterSubObj.length > 0) {
            setSubPath(filterSubObj[0].name);
          }
        } else {
          authService
            .logout()
            .catch((err) => console.error("Logout error:", err));
          dispatch(clearAuth());
          localStorage.clear();
          sessionStorage.clear();
          dispatch(resetStore());
          await persistor.flush();
          await persistor.purge();
          localStorage.clear();
          sessionStorage.clear();
          Cookies.remove("userName");
          Cookies.remove("userPassword");
          Cookies.remove("AccessToken");
          // navigate('/ats/login');
        }
      } else if (customerSubpathObj) {
        let subpath = {
          id: customerSubpathObj.id,
          name: customerSubpathObj.companyName,
          icon: "",
          type: "",
        };
        setSubPath(subpath.name);
      } else {
        setSubPath("Categories"); // TO DO
      }
    };
    processSubPath();
  }, [
    location,
    applicantsMenus,
    clientsMenus,
    customerMenus,
    helpSectionMenus,
    jobPostingMenus,
    projectsMenus,
  ]);

  const removelastSlash = (str) => {
    let path = str.replace("/ats/layout/", "");
    return path.slice(0, path.lastIndexOf("/"));
  };

  useEffect(() => {
    if (nextPathValue !== "" && nextPathValue !== "null") {
      setNextpath(nextPathValue);
    } else {
      setNextpath("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPathValue]);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  const getLinkedInPath = (linkedIn) => {
    if (linkedIn) {
      return linkedIn.includes("https") ? linkedIn : `https://${linkedIn}`;
    }
  };

  const applicantDetails = () => {
    if (aditionalData && Object.keys(aditionalData).length > 0) {
      return (
        <aside style={{ width: "86%" }} className="personal-details">
          {aditionalData?.currentWorking?.designation && (
            <span>
              {aditionalData.currentWorking.designation} <br />{" "}
              {aditionalData.currentWorking.from}
            </span>
          )}
          <div>
            {aditionalData?.emailId && (
              <span>
                <EmailIcon primaryFontColor={storedTheme?.secondaryColor} />
                <a href={"mailto:" + aditionalData.emailId}>
                  {aditionalData.emailId}
                </a>
              </span>
            )}
            {aditionalData?.contactNumber && (
              <span
                style={{
                  alignItems: aditionalData?.alternateContactNumber
                    ? ""
                    : "flex-end",
                }}
              >
                <PhoneIcon primaryFontColor={storedTheme?.secondaryColor} />{" "}
                {aditionalData.contactNumber} <br />
                {aditionalData.alternateContactNumber
                  ? `${aditionalData.alternateContactNumber}`
                  : ""}
              </span>
            )}
            {aditionalData?.linkedIn && (
              <span>
                <LinkedInIcon primaryFontColor={storedTheme?.secondaryColor} />{" "}
                <a
                  target="_blank"
                  href={getLinkedInPath(aditionalData.linkedIn)}
                >
                  LinkedIn
                </a>
              </span>
            )}
            {aditionalData?.location && (
              <span style={{ wordBreak: aditionalData.location.replace(/,/g, ", ").includes(" ") ? "" : "break-all" }}>
                <AddressIcon primaryFontColor={storedTheme?.secondaryColor} />
                {aditionalData.location.replace(/,/g, ", ")}
              </span>
            )}
          </div>
        </aside>
      );
    }
    return null;
  };

  const jobPostingDetails = () => {
    if (aditionalData && Object.keys(aditionalData).length > 0) {
      return (
        <aside style={{ width: "86%" }} className="personal-details">
          {aditionalData?.lastUpdated && (
            <span
              style={{
                fontStyle: "italic",
                fontSize: "14px",
                letterSpacing: "0px",
                color: "#6F6F6F",
                marginBottom: "6px",
              }}
            >
              Last Updated : {aditionalData?.lastUpdated}
            </span>
          )}
          {aditionalData?.jobType && <span>{aditionalData.jobType}</span>}
          {aditionalData?.workModel && <span>{aditionalData.workModel}</span>}
          <div>
            {aditionalData?.jobLocation && (
              <span>
                <AddressIcon primaryFontColor={storedTheme?.secondaryColor} />
                {aditionalData.jobLocation}{" "}
              </span>
            )}
            {aditionalData?.experience && (
              <span>
                <ExperienceIcon
                  primaryFontColor={storedTheme?.secondaryColor}
                />
                {aditionalData.experience}{" "}
              </span>
            )}
            {aditionalData?.segment && (
              <span>
                <SegmentIcon primaryFontColor={storedTheme?.secondaryColor} />
                {aditionalData.segment}{" "}
              </span>
            )}
            {aditionalData?.priority && (
              <span>
                <PriorityIcon primaryFontColor={storedTheme?.secondaryColor} />
                {aditionalData.priority}{" "}
              </span>
            )}
          </div>
        </aside>
      );
    }
    return null;
  };

  const clientDetails = () => {
    if (aditionalData && Object.keys(aditionalData).length > 0) {
      return (
        <aside style={{ width: "86%" }} className="personal-details">
          {aditionalData?.status && (
            <span
              style={{
                color:
                  aditionalData.status === "Active" ? "#15803D" : "#FF0000",
                fontSize: "20px",
                fontWeight: "500",
                marginTop: "-18px",
              }}
            >
              {aditionalData.status}
            </span>
          )}
          {aditionalData?.createdAt && (
            <span>{`Created on ${aditionalData.createdAt}`}</span>
          )}
        </aside>
      );
    }
    return null;
  };

  return (
    <>
      {menuList !== null ? (
        <Drawer
          variant="permanent"
          className="navbarSection"
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              top: "90px",
              width: drawerWidth,
              boxShadow: "0px 3px 6px #00000029",
            },
          }}
          open
        >
          {menuType === "jobpostings" ? (
            <div
              className="navbarHedding jobdetailsIcon"
              style={{ justifyContent: "flex-start", gap: "20px" }}
            >
              {" "}
              {/* jobPostingNavbar - className */}
              <Suitcase primaryColor={storedTheme?.primaryColor} />
              {/* {aditionalData?.jobStatus && (
                                <Chip
                                    icon={<FiberManualRecordIcon color="#2e7d32" />}
                                    label={aditionalData?.jobStatus}
                                    variant="outlined"
                                    sx={{
                                        bgcolor: "#e8f5e9",
                                        color: "#2e7d32",
                                        borderColor: "#2e7d32",
                                        fontSize: '16px',
                                        fontWeight: '400',
                                        padding: '20px 13px',
                                        borderRadius: '30px',
                                        height: '22px',
                                    }}
                                />
                            )} */}
              <span title={subpath ? subpath : subPathName}>
                {truncateWords(subpath ? subpath : subPathName, 3, 20)}
              </span>
              {/* {jobPostingDetails()} */}
              {/* Job Postings */}
            </div>
          ) : menuType === "applicants" ? (
            <div
              className="navbarHedding"
              style={{ minHeight: "initial!important" }}
            >
              <ApplicantsIcon
                primaryColor={storedTheme?.primaryColor}
                primaryFontColor={storedTheme?.primaryFontColor}
              />
              <span
                title={
                  nextpath !== ""
                    ? nextpath
                    : subPathName
                      ? subPathName
                      : subpath
                }
              >
                {truncateWords(
                  nextpath !== ""
                    ? nextpath
                    : subPathName
                      ? subPathName
                      : subpath,
                  3,
                  20,
                )}
              </span>
              {applicantDetails()}
              {/* Applicants */}
            </div>
          ) : menuType === "clients" ? (
            <div
              className="navbarHedding"
              style={{ justifyContent: "flex-start", gap: "20px" }}
            >
              <ApplicantsIcon
                primaryColor={storedTheme?.primaryColor}
                primaryFontColor={storedTheme?.primaryFontColor}
              />

              <span title={subPathName ? subPathName : subpath}>
                {truncateWords(subPathName ? subPathName : subpath, 3, 20)}
              </span>
              {clientDetails()}
              {/* Clients */}
            </div>
          ) : menuType === "projects" ? (
            <div
              className="navbarHedding"
              style={{ justifyContent: "flex-start", gap: "20px" }}
            >
              <Suitcase primaryColor={storedTheme?.primaryColor} />

              <span title={subpath ? subpath : subPathName}>
                {truncateWords(subpath ? subpath : subPathName, 3, 20)}
              </span>
              {/* Projects */}
            </div>
          ) : menuType === "helpsection" ? (
            <div className="navbarHedding">
              <Video primaryColor={storedTheme?.primaryColor} />
              Categories
              {/* helpsection */}
            </div>
          ) : menuType === "customer" ? (
            <div
              className="navbarHedding"
              style={{ justifyContent: "flex-start", gap: "20px" }}
            >
              <Suitcase primaryColor={storedTheme?.primaryColor} />
              <span title={subpath ? subpath : subPathName}>
                {truncateWords(subpath ? subpath : subPathName, 3, 20)}
              </span>
              {/* customer */}
            </div>
          ) : (
            ""
          )}
          <List>
            {menuList &&
              menuList?.map((item, index) => {
                if (isAssociat !== "") {
                  if (
                    item.menuName !== "Associated Jobs" &&
                    item.menuName !== "Associated Applicants"
                  ) {
                    return (
                      <ListItem
                        key={index}
                        onClick={() => onNavigateHandle(item)}
                        className={
                          activeMenu === item.menuName
                            ? "active navbarList"
                            : "navbarList"
                        }
                      >
                        <ListItemButton>
                          {/* <img src={(activeMenu === item.menuName) ?  : item.img} alt={item.menuName} /> */}
                          {activeMenu === item.menuName
                            ? item.activeImg
                            : item.img}

                          <ListItemText primary={item.menuName} />
                        </ListItemButton>
                      </ListItem>
                    );
                  }
                } else {
                  return (
                    <ListItem
                      key={index}
                      onClick={() => onNavigateHandle(item)}
                      className={
                        activeMenu === item.menuName
                          ? "active navbarList"
                          : "navbarList"
                      }
                    >
                      <ListItemButton>
                        {/* <img src={(activeMenu === item.menuName) ? item.activeImg : item.img} alt={item.menuName} /> */}
                        {activeMenu === item.menuName
                          ? item.activeImg
                          : item.img}
                        <ListItemText primary={item.menuName} />
                      </ListItemButton>
                    </ListItem>
                  );
                }
              })}
          </List>
        </Drawer>
      ) : null}
    </>
  );
}

export default NavSidebar;
